<template>
  <nav class="navbar navbar-light" style="background-color: #0b3d92">
    <div
      class="container-fluid d-flex flex-column justify-content-center align-items-center"
    >
      <a class="navbar-brand" style="color: #b9c8e0">
        <img src="../src/assets/img/logo.png" height="80px" />
        <!-- <img src="../src/assets/img/logo-jdccpp.png" height="80px" /> -->
      </a>
      <h5 style="color: white">CENA DE CONFRATERNIDAD CONTABLE 2025</h5>
    </div>
  </nav>
  <div class="container-fluid">
    <router-view></router-view>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
